export const STORAGE_SEPARATOR = '|';
export const STORAGE_PREFIX = 'ng2-webstorage';
